import { Native } from '../../utils/native/native';
import { cookies } from '../../utils/storage/cookies';

/** Logs out the native app safely */
const logoutNative = () => {
  try {
    Native.postMessage('Logout');
  } catch {}
};

const getCookie = (name: string) => {
  let regex = new RegExp('(^| )' + name + '=([^;]+)');
  let match = document.cookie.match(regex);
  if (match) {
    return true;
  }
  return false;
};

const checkIfHasSessionRefreshToken = () => {
  return !!getCookie('Authentication-Session-Refresh-Token');
};

const removeLegacySessionFromStorage = () => {
  try {
    localStorage.removeItem('gb_session');
    cookies.removeItem('gb_session');
  } catch {}
};

export { checkIfHasSessionRefreshToken, logoutNative, removeLegacySessionFromStorage };
